import { localStorageRemoveChatTriggersKeys } from './utils';

export class DebounceSet {
    timeoutIds: Record<string|number, ReturnType<typeof setTimeout>> = {}

    debounce (id: string, delay: number, callback: () => void) {
      const timeoutId = setTimeout(() => {
        if (this.timeoutIds[id] === timeoutId) {
          delete this.timeoutIds[id];
          localStorage.removeItem(id);
          callback();
        }
      }, delay);
      this.timeoutIds[id] = timeoutId;
    }

    clear (id: string|number) {
      // Clear the existing timeout for the given id
      const timeoutId = this.timeoutIds[id];
      if (timeoutId) {
        clearTimeout(timeoutId);
        delete this.timeoutIds[id];
      }
    }

    clearAll () {
      // Clear all existing timeouts
      Object.keys(this.timeoutIds).forEach((id) => {
        this.clear(id);
      });
      localStorageRemoveChatTriggersKeys();
    }
}
